import { Stack, Text, Container } from '../../components'
import { ManageCreditCards, ManageZumBankAccounts } from '.'
import { useAdvisorPermissions } from '../../hooks/useAdvisorPermissions'

export function PaymentMethodsLayout() {
  const { isAdvisorImpersonating } = useAdvisorPermissions()

  if (isAdvisorImpersonating) {
    return (
      <Container>
        <Text.H2>Access Restricted</Text.H2>
        <Text.Body>Your access level does not permit this action.</Text.Body>
      </Container>
    )
  }

  return (
    <Stack>
      <ManageCreditCards />
      <ManageZumBankAccounts />
    </Stack>
  )
}
